module.exports = __webpack_public_path__ + "img/test12.d0326995.jpeg";